import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { useModal } from 'hooks'

// NOTE: hook that exposes edit interview template name modal
// state and handlers for other local hooks and interview
// templates creator components
export const useEditNameModal = (state, handlers) => {
  const { uuid } = state
  const {
    handleSetResponse,
    handlePatchTemplate,
    handleShowSnackbar,
  } = handlers

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleConfirm = React.useCallback(
    async ({ title }, { onError }) => {
      const { error, meta, response } = await handlePatchTemplate({
        title,
        uuid,
      })

      if (response) {
        handleSetResponse(prevState =>
          R.mergeDeepRight(prevState, R.pick(['title'], response)),
        )
        handleClose()
        handleShowSnackbar({
          message: t`Interview template name was successully updated.`,
          type: 'success',
        })
      } else {
        onError({ message: error, type: meta.HTTPstatus })
      }
    },
    [
      uuid,
      handleClose,
      handleSetResponse,
      handlePatchTemplate,
      handleShowSnackbar,
    ],
  )

  return {
    handleEditNameClose: handleClose,
    handleEditNameConfirm: handleConfirm,
    handleEditNameOpen: handleOpen,
    isEditNameOpen: isOpen,
  }
}
